// import React from 'react';
import {Modal, ProgressBar} from 'react-bootstrap';
import createReactClass from 'create-react-class';

import {DESIGN} from '../global/libs/CONFIG.js';
import myAjax from '../global/libs/myAjax.js';
import PropTypes from 'prop-types';

let TrainModal = createReactClass({
  // ARGS: showModal, closeModal, generateAlert
  // Children: message
  propTypes: {
    showModal: PropTypes.bool,
    closeModal: PropTypes.func,
    generateAlert: PropTypes.func,
    gotoNextPanel: PropTypes.func,
    children: PropTypes.string
  },

  getInitialState: function () {
    return {trainProgress: 0};
  },

  UNSAFE_componentWillReceiveProps: function (nextProps) {
    if (nextProps.showModal === true) {
      this.setState({trainProgress: 0});
      this.trainModel();
    }
  },

  trainModel: function () {
    let closeModal = this.props.closeModal;
    let gotoNextPanel = this.props.gotoNextPanel;
    let generateAlert = this.props.generateAlert;

    myAjax('/api/models/train/').done(
      function () {
        this.setState({trainProgress: 100});
        closeModal();
        gotoNextPanel();
        generateAlert();
      }.bind(this)
    );
  },

  render: function () {
    return (
      <div>
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html: '.modal-dialog{margin-top: calc(50vh - 64px);}'
          }}
        />
        <Modal show={this.props.showModal}>
          <Modal.Header>
            {DESIGN.TRAIN}
            <Modal.Title>{this.props.children}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ProgressBar active now={this.state.trainProgress} />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
});

export default TrainModal;
